import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 850;
const RESULTS_BREAKPOINT = 960;

function getResponsiveState(hitsLength = null) {
  if (typeof window === 'undefined') {
    return { isMobile: false, initialResults: 3 };
  }

  const width = window.innerWidth;
  
  // Si se proporciona la longitud de hits, usarla como initialResults
  let initialResults;
  if (hitsLength !== null && hitsLength > 0) {
    initialResults = hitsLength;
  } else {
    initialResults = width <= RESULTS_BREAKPOINT ? 10 : 3;
  }

  return {
    isMobile: width <= MOBILE_BREAKPOINT,
    initialResults,
  };
}

/**
 * Centraliza los breakpoints usados por la búsqueda y sus paneles.
 * 
 * @param {number|null} hitsLength - Longitud del array de hits desde search_v3 (opcional).
 *                                   Si se proporciona, se usa como initialResults en lugar de calcularlo por viewport.
 * @returns {Object} Objeto con isMobile y initialResults
 */
export function useResponsive(hitsLength = null) {
  const [responsive, setResponsive] = useState(() => getResponsiveState(hitsLength));

  useEffect(() => {
    const updateResponsiveState = () => {
      const nextState = getResponsiveState(hitsLength);
      setResponsive(previous => (
        previous.isMobile === nextState.isMobile
        && previous.initialResults === nextState.initialResults
          ? previous
          : nextState
      ));
    };

    window.addEventListener('resize', updateResponsiveState);
    return () => window.removeEventListener('resize', updateResponsiveState);
  }, [hitsLength]);

  return responsive;
}